import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLubuntuComponent } from './simple-icons-lubuntu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLubuntuComponent ],
    exports:      [ SimpleIconsLubuntuComponent ],
    bootstrap:    []
})
export class SimpleIconsLubuntuModule {}
